angular.module("UI8.components").component("home", {
  template:
    `<section class="hero">
      <div class="hero__sphere" id="hero-sphere"></div>
      <div class="hero__content">
        <h1 class="hero__title">{{ ::$ctrl.heroTitleLine1 }}<span class="hero__title-line2" ng-if="::$ctrl.heroTitleLine2">{{ ::$ctrl.heroTitleLine2 }}</span></h1>
        <p class="hero__subtitle">{{ ::$ctrl.heroSubtitle }}</p>
        <div class="hero__tabs" role="tablist" id="hero-tabs">
          <div class="hero__tabs-border" id="search-border"></div>
          <div class="hero__tabs-pill" aria-hidden="true"></div>
          <button class="hero__tab is-active" role="tab" data-tab="featured" aria-selected="true">Featured</button>
          <button class="hero__tab" role="tab" data-tab="trending" aria-selected="false">Trending</button>
          <button class="hero__tab" role="tab" data-tab="recent" aria-selected="false">Recent</button>
        </div>
      </div>
    </section>` +
    `<div class="home">
      <div class="container">
        <div class="catalog home-catalog">
          <product-card ng-repeat="product in $ctrl.activeProducts track by product._id" product="product" user="$ctrl.user"></product-card>
        </div>
        <div class="cta-row">
          <div class="cta-row__text">
            <svg class="icon-badge" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M2.0315 12C2.0312 11.8662 2.00492 11.7325 1.95265 11.6065L1.23121 9.85975C1.07879 9.49188 1.00006 9.09699 1 8.69879C0.999936 8.30038 1.07838 7.90585 1.23084 7.53776C1.3833 7.16967 1.6068 6.83523 1.88856 6.55355C2.17025 6.27194 2.50465 6.04858 2.87267 5.89623L4.6166 5.17384C4.86916 5.06941 5.0706 4.86887 5.17575 4.61659L5.8983 2.87214C6.20608 2.12905 6.79645 1.53866 7.53953 1.23085C8.28261 0.923049 9.11753 0.923048 9.86061 1.23085L11.6037 1.9529C11.8567 2.05733 12.141 2.0572 12.3938 1.95231L12.3958 1.95149L14.1404 1.23192C14.8832 0.924529 15.7183 0.924429 16.4611 1.23209C17.204 1.53984 17.7943 2.13006 18.1021 2.87295L18.8073 4.57552C18.8136 4.58896 18.8196 4.60259 18.8253 4.61641C18.9298 4.86924 19.1304 5.07024 19.383 5.1753L21.1279 5.8981C21.871 6.20591 22.4614 6.7963 22.7692 7.53939C23.0769 8.28247 23.0769 9.11739 22.7692 9.86048L22.0468 11.6045C21.9943 11.7311 21.9681 11.8661 21.9681 12.0003C21.9681 12.1345 21.9943 12.2689 22.0468 12.3955L22.7692 14.1395C23.0769 14.8826 23.0769 15.7175 22.7692 16.4606C22.4614 17.2037 21.871 17.7941 21.1279 18.1019L19.383 18.8247C19.1304 18.9298 18.9298 19.1308 18.8253 19.3836C18.8196 19.3974 18.8136 19.411 18.8073 19.4245L18.1021 21.127C17.7943 21.8699 17.204 22.4602 16.4611 22.7679C15.7183 23.0756 14.8832 23.0755 14.1404 22.7681L12.3958 22.0485L12.3938 22.0477C12.141 21.9428 11.8567 21.9427 11.6037 22.0471L9.86061 22.7691C9.11753 23.077 8.28261 23.077 7.53953 22.7691C6.79645 22.4613 6.20608 21.8709 5.8983 21.1279L5.17575 19.3834C5.0706 19.1311 4.86916 18.9306 4.6166 18.8262L2.87267 18.1038C2.50465 17.9514 2.17025 17.7281 1.88856 17.4465C1.6068 17.1648 1.3833 16.8303 1.23084 16.4622C1.07838 16.0941 0.999936 15.6996 1 15.3012C1.00006 14.903 1.07879 14.5081 1.23121 14.1402L1.95265 12.3935C2.00492 12.2675 2.0312 12.1338 2.0315 12Z" fill="#00A656"></path>
              <path d="M8.5 12L10.5 14L15.5 9" fill="none" stroke="#121212" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            The best design assets from top creators, curated and updated every day.
          </div>
          <button class="new-btn" ng-click="$ctrl.openSearch()">Explore products</button>
        </div>
        <apps-promo variant="home"></apps-promo>
        <h2 class="home-title">Browse by category</h2>
        <div class="categories">
          <a
            class="categories__card"
            ng-repeat="category in $ctrl.categories track by category.name"
            ng-href="/category/{{category.slug}}"
          >
            <div class="categories__img">
              <img ng-src="{{category.imageUrl}}" alt="{{category.name}}" loading="lazy">
            </div>
            <div class="categories__info">
              <span class="categories__name">{{category.name}}</span>
              <span class="categories__fmt">{{category.formats}}</span>
            </div>
          </a>
        </div>
        <div class="cta-row m-hide">
          <div class="cta-row__text">
            <svg class="icon-send" viewBox="0 0 24 24">
              <path d="M20.9071 6.20616C21.4792 4.29915 19.7012 2.52112 17.7941 3.09322L2.86855 7.5709C0.476698 8.28846 0.499004 11.6832 2.90011 12.3693L9.42373 14.2332C9.58983 14.2806 9.71967 14.4105 9.76713 14.5766L11.631 21.1002C12.3171 23.5013 15.7118 23.5236 16.4294 21.1318L20.9071 6.20616Z"/>
            </svg>
            More products and tools are coming soon, stay in loop!
          </div>
          <div class="nl-input">
            <div class="nl-input__border" id="nl-border"></div>
            <span class="nl-input__placeholder" id="nl-placeholder">Enter your email</span>
            <input type="text" inputmode="email" id="nl-field" maxlength="50" placeholder=" " autocomplete="one-time-code" data-1p-ignore data-lpignore="true" data-form-type="other">
            <span class="nl-input__status" id="nl-status"></span>
            <div class="nl-input__indicator" id="nl-indicator"></div>
          </div>
        </div>
` +
    // "See what's trending" section parked 2026-07 — redundant with the
    // hero's Trending tab (data still feeds the tab). Uncomment to restore.
    // <h2 class="home-title">See what's trending</h2>
    // <div class="catalog">
    // <product-card ng-repeat="product in $ctrl.trendingProducts track by product._id" product="product" user="$ctrl.user"></product-card>
    // </div>
    // <div class="cta-row cta-row--marquee">
    // <div class="cta-row__text">
    // <svg class="icon-sparks" viewBox="0 0 24 24">
    // <path d="M14 8C14 7.44772 13.5523 7 13 7C12.4477 7 12 7.44772 12 8C12 10.3085 11.4892 11.7424 10.6158 12.6158C9.74243 13.4892 8.30849 14 6 14C5.44772 14 5 14.4477 5 15C5 15.5523 5.44772 16 6 16C8.30849 16 9.74243 16.5108 10.6158 17.3842C11.4892 18.2576 12 19.6915 12 22C12 22.5523 12.4477 23 13 23C13.5523 23 14 22.5523 14 22C14 19.6915 14.5108 18.2576 15.3842 17.3842C16.2576 16.5108 17.6915 16 20 16C20.5523 16 21 15.5523 21 15C21 14.4477 20.5523 14 20 14C17.6915 14 16.2576 13.4892 15.3842 12.6158C14.5108 11.7424 14 10.3085 14 8Z"/>
    // <path d="M6 5.5C6 5.22386 5.77614 5 5.5 5C5.22386 5 5 5.22386 5 5.5C5 6.48063 4.78279 7.0726 4.4277 7.4277C4.0726 7.78279 3.48063 8 2.5 8C2.22386 8 2 8.22386 2 8.5C2 8.77614 2.22386 9 2.5 9C3.48063 9 4.0726 9.21721 4.4277 9.5723C4.78279 9.9274 5 10.5194 5 11.5C5 11.7761 5.22386 12 5.5 12C5.77614 12 6 11.7761 6 11.5C6 10.5194 6.21721 9.9274 6.5723 9.5723C6.9274 9.21721 7.51937 9 8.5 9C8.77614 9 9 8.77614 9 8.5C9 8.22386 8.77614 8 8.5 8C7.51937 8 6.9274 7.78279 6.5723 7.4277C6.21721 7.0726 6 6.48063 6 5.5Z"/>
    // <path d="M11 1.5C11 1.22386 10.7761 1 10.5 1C10.2239 1 10 1.22386 10 1.5C10 2.13341 9.85918 2.47538 9.66728 2.66728C9.47538 2.85918 9.13341 3 8.5 3C8.22386 3 8 3.22386 8 3.5C8 3.77614 8.22386 4 8.5 4C9.13341 4 9.47538 4.14082 9.66728 4.33272C9.85918 4.52462 10 4.86659 10 5.5C10 5.77614 10.2239 6 10.5 6C10.7761 6 11 5.77614 11 5.5C11 4.86659 11.1408 4.52462 11.3327 4.33272C11.5246 4.14082 11.8666 4 12.5 4C12.7761 4 13 3.77614 13 3.5C13 3.22386 12.7761 3 12.5 3C11.8666 3 11.5246 2.85918 11.3327 2.66728C11.1408 2.47538 11 2.13341 11 1.5Z"/>
    // </svg>
    // Discover the most popular products this week
    // </div>
    // <a href="/trending" class="new-btn">Browse Trending</a>
    // </div>
    `      </div>
      <div class="container">
        <h2 class="home-title m-hide">Author Spotlight</h2>
        <p class="home-subtitle m-hide">Celebrating the creators behind your favorite design resources.</p>
        <featured-author products="$ctrl.featuredAuthorProducts.products" user="$ctrl.user"></featured-author>
        <section class="logos">
          <div class="logos__inner">
          <span class="logos__label">Trusted by</span>
          <div class="logos__track">
            <div class="logos__list">
              <img src="/img/companies/airbnb.svg" alt="Airbnb" loading="lazy">
              <img src="/img/companies/amazon.svg" alt="Amazon" loading="lazy">
              <img src="/img/companies/google.svg" alt="Google" loading="lazy">
              <img src="/img/companies/microsoft.svg" alt="Microsoft" loading="lazy">
              <img src="/img/companies/netflix.svg" alt="Netflix" loading="lazy">
              <img src="/img/companies/paypal.svg" alt="PayPal" loading="lazy">
              <img src="/img/companies/shopify.svg" alt="Shopify" loading="lazy">
              <img src="/img/companies/spotify.svg" alt="Spotify" loading="lazy">
              <img src="/img/companies/stripe.svg" alt="Stripe" loading="lazy">
              <img src="/img/companies/adobe.svg" alt="Adobe" loading="lazy">
              <img src="/img/companies/webflow.svg" alt="Webflow" loading="lazy">
            </div>
            <div class="logos__list">
              <img src="/img/companies/airbnb.svg" alt="Airbnb" loading="lazy">
              <img src="/img/companies/amazon.svg" alt="Amazon" loading="lazy">
              <img src="/img/companies/google.svg" alt="Google" loading="lazy">
              <img src="/img/companies/microsoft.svg" alt="Microsoft" loading="lazy">
              <img src="/img/companies/netflix.svg" alt="Netflix" loading="lazy">
              <img src="/img/companies/paypal.svg" alt="PayPal" loading="lazy">
              <img src="/img/companies/shopify.svg" alt="Shopify" loading="lazy">
              <img src="/img/companies/spotify.svg" alt="Spotify" loading="lazy">
              <img src="/img/companies/stripe.svg" alt="Stripe" loading="lazy">
              <img src="/img/companies/adobe.svg" alt="Adobe" loading="lazy">
              <img src="/img/companies/webflow.svg" alt="Webflow" loading="lazy">
            </div>
          </div>
          </div>
        </section>
      </div>`,

  controller: function ($timeout, HistoryService) {
    var ctrl = this;

    ctrl.activeProducts = [];

    ctrl.featuredProducts = [];
    ctrl.trendingProducts = [];
    ctrl.newReleasesProducts = [];

    ctrl.categories = [];

    ctrl.openSearch = function () {
      window.openSearch && window.openSearch();
    };

    ctrl.$onInit = function () {
      // Hero copy from admin Settings (group "home"). Placeholders: [count]
      // (active products) and [users] (active users). A "|" in the title
      // splits it into two lines (hero__title-line2). Hardcoded fallbacks
      // cover settings failing to load.
      var homeSettings = (ctrl.data.settings && ctrl.data.settings.home) || {};
      var heroTitle = (
        homeSettings.title ||
        "Design resources and AI tools|for your creative workflow"
      ).replace("[count]", ctrl.data.count || "");
      var titleParts = heroTitle.split("|");
      ctrl.heroTitleLine1 = titleParts[0].trim();
      ctrl.heroTitleLine2 = (titleParts[1] || "").trim();
      ctrl.heroSubtitle = (
        homeSettings.subtitle ||
        "Join over 1,000,000 creators shaping the future of design."
      ).replace("[users]", ctrl.data.users || "");

      ctrl.featuredProducts = ctrl.data.featured.products.slice(0, 24);
      ctrl.trendingProducts = ctrl.data.trending.products.slice(0, 24);
      ctrl.activeProducts = ctrl.featuredProducts;
      ctrl.newReleasesProducts = ctrl.data.new_releases.products.slice(0, 27);

      ctrl.categories = ctrl.data.categories || [];

      // Scroll to top
      window.scroll(0, 0);

      function isGoingToProduct(oldPath, oldUrl) {
        return oldPath === "/" && !oldUrl.includes("?search=1");
      }

      HistoryService.rememberScrollPosition(isGoingToProduct, "home");

      document.querySelectorAll("[data-href]").forEach((card) => {
        let startX, startY;
        card.addEventListener("mousedown", (e) => {
          startX = e.clientX;
          startY = e.clientY;
        });
        card.addEventListener("click", (e) => {
          const dx = Math.abs(e.clientX - startX),
            dy = Math.abs(e.clientY - startY);
          if (dx > 5 || dy > 5) return; // was a drag, not a click
          if (card.dataset.href.startsWith("http")) {
            window.open(card.dataset.href, "_blank");
            return;
          }
          window.location.href = card.dataset.href;
        });
      });
    };

    // UI animations
    ctrl.$postLink = function () {
      // Lazily init when el first enters viewport.
      // If createFn returns an instance with pause/resume, also manages
      // pause state on subsequent intersection changes.
      function observe(el, createFn) {
        if (!el) return;
        var instance = null;
        new IntersectionObserver(
          function (entries) {
            var vis = entries[0].isIntersecting;
            if (vis && !instance) instance = createFn() || {};
            if (instance && instance.pause) {
              if (vis) instance.resume();
              else instance.pause();
            }
          },
          { rootMargin: "200px" }
        ).observe(el);
      }

      // ── Above-fold: initialize immediately ──────────────────────
      var sphereEl = document.getElementById("hero-sphere");
      if (sphereEl) {
        (function waitForHero() {
          if (window.HeroSphere && window.HeroSphere.initHero) {
            // 30 of the 50 cards — see hero-sphere.js. Every sphere on the
            // site uses the same 30, so the second one a visitor meets costs
            // no downloads at all.
            var P = window.HeroSphere.initHero(
              sphereEl,
              "/img/cards/",
              document.querySelector(".hero__tabs"),
              30
            );
            observe(sphereEl, function () {
              return P;
            });
            var isTouch =
              "ontouchstart" in window || navigator.maxTouchPoints > 0;
            if (isTouch) {
              P.glassVisible = 1;
            } else {
              setTimeout(function () {
                var start = performance.now();
                (function fadeGlass() {
                  var t = Math.min(1, (performance.now() - start) / 1000);
                  P.glassVisible = t;
                  if (t < 1) requestAnimationFrame(fadeGlass);
                })();
              }, 600);
            }
          } else {
            requestAnimationFrame(waitForHero);
          }
        })();
      }

      var borderEl = document.getElementById("search-border");
      if (borderEl && window.SearchBorder) {
        window.SearchBorder.initSearchBorder(borderEl);
      }

      (function () {
        var tabsEl = document.getElementById("hero-tabs");
        if (!tabsEl) return;
        var tabs = tabsEl.querySelectorAll(".hero__tab");
        var catalogEl = document.querySelector(".home-catalog");
        var currentTab = "featured";
        var swapTimer = null;
        var tabData = {
          featured: ctrl.featuredProducts,
          trending: ctrl.trendingProducts,
          recent: ctrl.newReleasesProducts.slice(0, 24),
        };
        tabs.forEach(function (tab) {
          tab.addEventListener("click", function () {
            var next = tab.dataset.tab;
            if (next === currentTab) return;
            currentTab = next;
            tabs.forEach(function (t) {
              var active = t.dataset.tab === next;
              t.classList.toggle("is-active", active);
              t.setAttribute("aria-selected", active ? "true" : "false");
            });
            tabsEl.dataset.active = next;
            if (catalogEl) catalogEl.classList.add("is-swapping");
            clearTimeout(swapTimer);
            swapTimer = setTimeout(function () {
              $timeout(function () {
                ctrl.activeProducts = tabData[next];
              });
              if (catalogEl) catalogEl.classList.remove("is-swapping");
            }, 220);
          });
        });
      })();

      function playOnVisible(el) {
        if (!el) return;
        new IntersectionObserver(function (entries) {
          el.classList.toggle("is-playing", entries[0].isIntersecting);
        }).observe(el);
      }

      playOnVisible(document.querySelector(".logos__track"));

      var nlBorderEl = document.getElementById("nl-border");
      observe(nlBorderEl, function () {
        if (window.Newsletter) {
          window.Newsletter.initNewsletterBorder(nlBorderEl);
          window.Newsletter.initNewsletterInput(
            "nl-field",
            "nl-placeholder",
            "nl-status",
            "nl-indicator"
          );
        }
      });
    };
  },

  bindings: {
    data: "<",
    user: "<",
    featuredAuthorProducts: "<",
  },
});
